export const ApiHost = "https://api.kiorhealthcare.com";
export const ApiBaseUrl = `${ApiHost}/v1/user/`;
export const ApiBaseUrlV2 = `${ApiHost}/v2/user/`;
export const SiteUrl = "https://www.kiorhealthcare.com";

/** Razorpay Key ID (public). Prefer REACT_APP_RAZORPAY_KEY in .env */
export const RazorpayKeyId =
  process.env.REACT_APP_RAZORPAY_KEY || "rzp_live_TYxpQfvwqsEnT2";

/** Used for public catalog browsing when user is not logged in */
export const CatalogFallbackToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFhYXNzc0B5b3BtYWlsLmNvbSIsImlkIjoiNjM4YzhhYTUtYzU0NC00YzcxLWI3YWEtZTI2ZjBlOGZkNzFiIiwidXNlclR5cGUiOiJVU0VSIiwicGxhdGZvcm0iOiJXRUIiLCJpYXQiOjE3NDAzNzg0MjJ9.qTM6H1yVzhMhNDHsvdUHgcP22Oed8aX5hbFh_YwEW4";

export const AUTH_TOKEN_KEY = "kior_user_token";
export const AUTH_USER_KEY = "kior_user_data";
export const CART_KEY = "cart";

// v1 endpoints
export const endpoints = {
  login: "login",
  logout: "logout",
  forgotPassword: "forgotPassword",
  resetPassword: "resetPassword",
  resendOtp: "resendOtp",
  signup: "signup",
  verifyOtp: "verifyOtp",
  updateProfile: "updateProfile",
  getProfile: "getProfile",
  getAppVersions: "getAppVersions",
  home: "home",
  booking: "booking",
  allBookings: "AllBookings",
  uploadReport: "uploadReport",
  myBookings: "myBookings",
  myBookingDetails: "myBookingDetails",
  rescheduleOrCancelBooking: "rescheduleOrCancelBooking",
  createRazorpayOrder: "createRazorpayOrder",
  getCategoryTests: "getCategoryTests",
  getAllTests: "getAllTests",
  getPackageDetails: "getPackageDetails",
  submitFeedback: "submitFeedback",
  contactUs: "contactUs",
  myReports: "myReports",
  getBillReport: "getBillReport",
  checkCoupon: "checkCoupon",
  getCoupons: "getCoupons",
  getAddresses: "getAddresses",
  addAddress: "addAddress",
  updateAddress: "updateAddress",
  deleteAddress: "deleteAddress",
  websiteFeedback: "websiteFeedback",
  blogs: "blogs",
};

// v2 endpoints
export const endpointsV2 = {
  login: "login",
  verifyOtpV2: "verifyOtpV2",
};

// Legacy exports used by existing slices
export const homeApi = endpoints.home;
export const getAllTestsApi = endpoints.getAllTests;
export const getPackageDetailsApi = endpoints.getPackageDetails;
export const loginApi = endpoints.login;

export const GENDER = { MALE: 1, FEMALE: 2, OTHER: 3 };
export const PAYMENT_MODE = { CASH: 1, ONLINE: 2, CASH_ONLINE: 3, CARD: 4 };
export const BOOKING_STATUS = {
  PENDING: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  CANCELLED: 3,
};
export const ADDRESS_TYPE = { HOME: 1, WORK: 2, OTHER: 3 };
